import i18n from 'modules/core/lib/i18n'

export interface HealthInsurer {
  name: string
  codeEast: string | null
  codeWest: string
}

export const HEALTH_INSURERS: HealthInsurer[] = [
  { name: 'AOK Baden-Württemberg', codeEast: null, codeWest: '67450665' },
  { name: 'AOK Bavaria', codeEast: '87880235', codeWest: '87880235' },
  { name: 'AOK Bremen/Bremerhaven', codeEast: '20012084', codeWest: '20012084' },
  { name: 'AOK Hessen', codeEast: '45118687', codeWest: '45118687' },
  { name: 'AOK Lower Saxony', codeEast: '29720865', codeWest: '29720865' },
  { name: 'AOK Northeast', codeEast: '01000126', codeWest: '90235319' },
  { name: 'AOK NordWest', codeEast: '33526082', codeWest: '33526082' },
  { name: 'AOK PLUS', codeEast: '05174740', codeWest: '01000159' },
  { name: 'AOK Rhineland-Palatinate/Saarland', codeEast: '51605725', codeWest: '51605725' },
  { name: 'AOK Rheinland/Hamburg', codeEast: '15039702', codeWest: '34364249' },
  { name: 'AOK Saxony-Anhalt', codeEast: '01029141', codeWest: '01029141' },
  { name: 'Audi BKK', codeEast: '01083422', codeWest: '82889062' },
  { name: 'BAHN-BKK', codeEast: '08316149', codeWest: '49003443' },
  { name: 'BARMER', codeEast: '42938966', codeWest: '42938966' },
  { name: 'BERGISCHE health insurance fund', codeEast: '42039708', codeWest: '42039708' },
  { name: 'Bertelsmann BKK', codeEast: '31323584', codeWest: '31323584' },
  { name: 'BIG directly healthy', codeEast: '05012943', codeWest: '97141402' },
  { name: 'BKK Akzo Nobel Bayern', codeEast: '71579930', codeWest: '71579930' },
  { name: 'BKK Diakonie', codeEast: '31323686', codeWest: '31323686' },
  { name: 'BKK DürkoppAdler', codeEast: '31323799', codeWest: '31323799' },
  { name: 'BKK EUREGIO', codeEast: '30168049', codeWest: '30168049' },
  { name: 'BKK exclusive', codeEast: '03591039', codeWest: '22178373' },
  { name: 'BKK Faber-Castell & Partner', codeEast: '86772584', codeWest: '86772584' },
  { name: 'BKK firmus', codeEast: '01058922', codeWest: '20156168' },
  { name: 'BKK Freudenberg', codeEast: '63922962', codeWest: '63922962' },
  { name: 'BKK GILDEMEISTER SILK STICKERS', codeEast: '01011777', codeWest: '31323802' },
  { name: 'BKK Herkules', codeEast: '47034953', codeWest: '47034953' },
  { name: 'BKK Linde', codeEast: '01085457', codeWest: '48698889' },
  { name: 'BKK Melitta HMR', codeEast: '36916935', codeWest: '36916935' },
  { name: 'BKK mkk', codeEast: '08476370', codeWest: '92644250' },
  { name: 'BKK PFAFF', codeEast: '01085446', codeWest: '51588416' },
  { name: 'BKK Pfalz', codeEast: '07251093', codeWest: '52598579' },
  { name: 'BKK ProVita', codeEast: '08090728', codeWest: '88571250' },
  { name: 'BKK Public', codeEast: '21488086', codeWest: '21488086' },
  { name: 'BKK SBH', codeEast: '66614249', codeWest: '66614249' },
  { name: 'BKK Scheufelen', codeEast: '99618572', codeWest: '61232758' },
  { name: 'BKK Technoform', codeEast: '23446040', codeWest: '23446040' },
  { name: 'BKK VDN', codeEast: '04309904', codeWest: '37416328' },
  { name: 'BKK VerbundPlus', codeEast: '01049156', codeWest: '69785429' },
  { name: 'BKK WERRA-MEISSNER', codeEast: '44037562', codeWest: '44037562' },
  { name: 'BKK Business & Finance', codeEast: '06785450', codeWest: '46967693' },
  { name: 'BKK24', codeEast: '02430065', codeWest: '23709856' },
  { name: 'BOSCH BKK', codeEast: '01073497', codeWest: '67572593' },
  { name: 'Continentale company health insurance', codeEast: '33865367', codeWest: '33865367' },
  { name: 'DAK-Health', codeEast: '15035218', codeWest: '15035218' },
  { name: 'Debeka BKK', codeEast: '52156763', codeWest: '52156763' },
  { name: 'energie-BKK', codeEast: '01085812', codeWest: '29717581' },
  { name: 'Home Health Insurance', codeEast: '31209131', codeWest: '31209131' },
  { name: 'HEK-Hanseatic Health Insurance', codeEast: '15031806', codeWest: '15031806' },
  { name: 'hkk', codeEast: '20013461', codeWest: '20013461' },
  { name: 'IKK - The Innovation Fund', codeEast: '14228571', codeWest: '14228571' },
  { name: 'IKK Brandenburg and Berlin', codeEast: '01020803', codeWest: '90397224' },
  { name: 'IKK classic', codeEast: '01049203', codeWest: '01049203' },
  { name: 'IKK gesund plus', codeEast: '01000455', codeWest: '20013109' },
  { name: 'IKK Südwest', codeEast: '55811201', codeWest: '55811201' },
  { name: 'KKH Commercial Health Insurance', codeEast: '29137937', codeWest: '29137937' },
  { name: 'KNAPPSCHAFT', codeEast: '98000006', codeWest: '98000006' },
  { name: 'mhplus BKK', codeEast: '07812433', codeWest: '63494759' },
  { name: 'Mobile health insurance', codeEast: '15517302', codeWest: '15517302' },
  { name: 'novitas bkk', codeEast: '03847834', codeWest: '35134022' },
  { name: 'Pronova BKK', codeEast: '15872672', codeWest: '15872672' },
  { name: 'R+V company health insurance', codeEast: '01085890', codeWest: '48944809' },
  { name: 'Salus BKK', codeEast: '01085195', codeWest: '44953697' },
  { name: 'SBK', codeEast: '01085787', codeWest: '87954699' },
  { name: 'SECURVITA Health Insurance', codeEast: '01085402', codeWest: '15517482' },
  { name: 'SKD BKK', codeEast: '01085242', codeWest: '74773896' },
  { name: 'Technicians Health Insurance', codeEast: '15027365', codeWest: '15027365' },
  { name: 'TUI BKK', codeEast: '08227948', codeWest: '29074470' },
  { name: 'VIACTIV Health Insurance', codeEast: '40180080', codeWest: '40180080' },
  { name: 'vivida bkk', codeEast: '06818233', codeWest: '66458477' },
  { name: 'WMF BKK', codeEast: '01085231', codeWest: '61232769' },
  { name: 'ZF BKK', codeEast: '69753266', codeWest: '69753266' },
]

export interface HealthInsurerOption {
  code: string
  label: string
  searchValue: string
}

export function getHealthInsurerOptions(): HealthInsurerOption[] {
  const options: HealthInsurerOption[] = []
  const eastLabel = i18n.t('employee_form.payroll_data.health_insurer_east')
  const westLabel = i18n.t('employee_form.payroll_data.health_insurer_west')

  HEALTH_INSURERS.forEach((insurer) => {
    const hasOnlyWest = !insurer.codeEast
    const hasSameCode = insurer.codeEast === insurer.codeWest

    if (hasOnlyWest) {
      options.push({
        code: insurer.codeWest,
        label: `${insurer.name} - ${westLabel}`,
        searchValue: `${insurer.name} ${westLabel} ${insurer.codeWest}`,
      })
    } else if (hasSameCode) {
      options.push({
        code: insurer.codeWest,
        label: insurer.name,
        searchValue: `${insurer.name} ${insurer.codeWest}`,
      })
    } else if (insurer.codeEast) {
      options.push({
        code: insurer.codeEast,
        label: `${insurer.name} - ${eastLabel}`,
        searchValue: `${insurer.name} ${eastLabel} ${insurer.codeEast}`,
      })
      options.push({
        code: insurer.codeWest,
        label: `${insurer.name} - ${westLabel}`,
        searchValue: `${insurer.name} ${westLabel} ${insurer.codeWest}`,
      })
    }
  })

  return options.sort((a, b) => a.label.localeCompare(b.label))
}

export const HEALTH_INSURERS_BY_CODE = new Map<string, HealthInsurer>()
HEALTH_INSURERS.forEach((insurer) => {
  if (insurer.codeEast) {
    HEALTH_INSURERS_BY_CODE.set(insurer.codeEast, insurer)
  }
  HEALTH_INSURERS_BY_CODE.set(insurer.codeWest, insurer)
})

export function getHealthInsurerLabel(code: string): string | null {
  if (!code) {
    return null
  }

  const insurer = HEALTH_INSURERS_BY_CODE.get(code)
  if (!insurer) {
    return code
  }

  const hasOnlyWest = !insurer.codeEast
  const hasSameCode = insurer.codeEast === insurer.codeWest

  if (hasOnlyWest) {
    return `${insurer.name} - ${i18n.t('employee_form.payroll_data.health_insurer_west')}`
  } else if (hasSameCode) {
    return insurer.name
  } else {
    const isEastCode = insurer.codeEast === code
    const regionLabel = isEastCode
      ? i18n.t('employee_form.payroll_data.health_insurer_east')
      : i18n.t('employee_form.payroll_data.health_insurer_west')
    return `${insurer.name} - ${regionLabel}`
  }
}
